import React, { useState } from 'react'
import ProductCard from '../Card/ProductCard'
import Search from '../Search/Search'
import { carLists } from '../../constants'

const Product = () => {
  const [cars] = useState(carLists);
  const [searchValue, setSearchValue] = useState("");

  const onHandleChange = (e) => {
    setSearchValue(e.target.value)
  }

  const filteredCars = cars.filter(car => {
    return(
      car.name.toLowerCase().includes(searchValue.toLowerCase()) || 
      car.year.toLowerCase().includes(searchValue.toLowerCase()) || 
      car.type.toLowerCase().includes(searchValue.toLowerCase()) ||
      car.brand.toLowerCase().includes(searchValue.toLowerCase())
    )
  });

  return (
    <section id='produk' className='background-black text-light'>
      <div className="custom-shape-divider-top-1676278851">
          <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
              <path d="M0,0V7.23C0,65.52,268.63,112.77,600,112.77S1200,65.52,1200,7.23V0Z" className="shape-fill"></path>
          </svg>
      </div>
      <div className="container text-center color-secondary">
        <div className='mb-4'>
          <h2 className='mb-3'>Daftar Mobil</h2>
          <h6 className='desc'>Perjalanan anda di kota Palu akan dimudahkan oleh jasa kami</h6>
        </div>
        <Search onHandleChange={onHandleChange}/>
        {
          filteredCars.length === 0 ?  <h4 className='color-secondary mt-5'>Kendaraan tidak ditemukan !</h4> : <ProductCard cars={filteredCars}/>
        }
      </div>
    </section>
  )
}

export default Product